function getColoredSVG({ image, primary, secondary }) {
  switch (image) {
    case 'new_conversation':
      return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <defs><style>.cls-1{fill:${primary};}.cls-2{fill:${secondary};}</style></defs><title>Convo History_New Conversation_Rollover</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Chat_History" data-name="Chat History">
          <path class="cls-2" d="M22.5,9.05A1.5,1.5,0,0,0,21,7.55H9a1.51,1.51,0,0,0-1.5,1.5v9A1.5,1.5,0,0,0,9,19.55H19.5l3,3ZM18,14.3H15.75v2.25a.75.75,0,0,1-1.5,0V14.3H12a.75.75,0,0,1,0-1.5h2.25V10.55a.75.75,0,0,1,1.5,0V12.8H18a.75.75,0,0,1,0,1.5Z"/>
        </g>
      </g>
    </svg>
    `
    case 'prompt':
    default:
      return `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 1000 1000" style="enable-background:new 0 0 1000 1000;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:${secondary};}
      </style>
      <g>
        <g>
          <path class="st0" d="M835.54,576.73c-31.47-96.79-122.36-166.77-229.64-166.77h-73.79v-58.67c28-12.42,47.56-40.41,47.56-73.02
            c0-44.12-35.76-79.88-79.88-79.88s-79.88,35.76-79.88,79.88c0,32.6,19.56,60.6,47.56,73.02v58.67h-73.79
            c-107.28,0-198.17,69.98-229.64,166.77c-36.48,5.39-64.5,36.73-64.5,74.71c0,37.97,28.02,69.32,64.5,74.71
            c31.47,96.79,122.36,166.77,229.64,166.77h129.97l182.42,97.35c11.31,6.04,23.57-6.29,17.47-17.57l-48.63-89.85
            c75.94-22.62,136.19-81.57,160.62-156.71c36.48-5.39,64.5-36.73,64.5-74.71C900.04,613.46,872.02,582.12,835.54,576.73z
              M605.9,853.89H393.69c-111.63,0-202.45-90.82-202.45-202.45c0-111.63,90.82-202.45,202.45-202.45H605.9
            c111.63,0,202.45,90.82,202.45,202.45S717.53,853.89,605.9,853.89z"/>
          <circle class="st0" cx="342.95" cy="606.06" r="72.21"/>
          <circle class="st0" cx="577.11" cy="606.06" r="72.21"/>
        </g>
        <g>
          <path class="st0" d="M355.4,292.91H244.16c-8.08,0-14.64-6.55-14.64-14.64c0-8.08,6.55-14.64,14.64-14.64H355.4
            c8.08,0,14.64,6.55,14.64,14.64C370.03,286.35,363.48,292.91,355.4,292.91z"/>
          <path class="st0" d="M755.43,292.91H644.18c-8.08,0-14.64-6.55-14.64-14.64c0-8.08,6.55-14.64,14.64-14.64h111.24
            c8.08,0,14.64,6.55,14.64,14.64C770.06,286.35,763.51,292.91,755.43,292.91z"/>
        </g>
        <g>
          <path class="st0" d="M397.69,190.8c-3.74,0-7.49-1.43-10.35-4.29l-78.65-78.65c-5.72-5.71-5.72-14.98,0-20.7
            c5.72-5.72,14.98-5.72,20.7,0l78.65,78.65c5.72,5.71,5.72,14.98,0,20.7C405.18,189.37,401.43,190.8,397.69,190.8z"/>
        </g>
        <g>
          <path class="st0" d="M601.89,190.8c-3.74,0-7.49-1.43-10.35-4.29c-5.72-5.71-5.72-14.98,0-20.7l78.65-78.65
            c5.72-5.72,14.98-5.72,20.7,0c5.72,5.71,5.72,14.98,0,20.7l-78.65,78.65C609.38,189.37,605.64,190.8,601.89,190.8z"/>
        </g>
        <g>
          <path class="st0" d="M499.79,148.51c-8.08,0-14.64-6.55-14.64-14.64V22.64c0-8.08,6.55-14.64,14.64-14.64
            c8.08,0,14.64,6.55,14.64,14.64v111.24C514.43,141.96,507.88,148.51,499.79,148.51z"/>
        </g>
      </g>
    </svg>
    `
  }
}

export { getColoredSVG }
